import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import Qs from 'qs'
import store from '@/store'


// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: '/',
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

axios.defaults.baseURL = '/api';

//get请求时，参数转换
_axios.defaults.paramsSerializer = (params) => {
  return Qs.stringify(params);
}
//post请求时，参数转换
_axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

_axios.interceptors.request.use(
  function (config) { // Do something before request is sent
    if (!config.headers['Authorization']) {
      // console.log("默认添加token");
      let token = localStorage.getItem("token");
      if (token) {
        //每个请求携带 token
        config.headers['Authorization'] = "Bearer " + token;
      }
    }
    return config;
  },
  function (error) {  // Do something with request error
    console.log('request_error', error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
// 添加一个 response 拦截器
_axios.interceptors.response.use(
  async function (response) { // Do something with response data

    // console.log(response);
    let res = response.data;
    if (response.request.responseType == 'blob') {
      if (response.headers["content-type"].indexOf("application/json") == -1) {
        return response;
      }
      async function convertJson() {
        return new Promise((resolve, reject) => {
          console.log('resolve');
          // console.log(resolve);
          let reader = new FileReader();
          reader.onload = e => {
            resolve(JSON.parse(e.target.result));
          };
          reader.readAsText(res);
        })
      }
      res = await convertJson();
    }

    return res;
  },
  async function (error) { // Do something with response error
    console.log('response_error', JSON.parse(JSON.stringify(error)));
    if (error.response.status == 401) {
      if (!store.state.user.unauthorized) {
        store.dispatch('setUnauthorized', true);
        MessageBox({ title: "提示", message: "登录信息失效，点击跳转到授权页面", type: 'error' }).then(res => {
          console.log(store.state)
          if (process.env.NODE_ENV != "development") {
            store.dispatch('clearStorage');
            var redirect_uri = "https://pddprint.zhipengai.com"
            window.location.href = "https://fuwu.pinduoduo.com/service-market/auth?response_type=code&client_id=c69f227af0cc4b3d81746242b695b1d1&redirect_uri=" + redirect_uri;
          }
        })
      }
    }
    if (error.response.status == 400) {
      var msg = error.response.data ? error.response.data.errorMessage : "参数错误";
      Message({ message: msg, type: "error" });
    }
    if (error.response.status == 500) {
      Message({ message: "服务器未响应", type: "error" });
    }
    return Promise.reject(error.response);
  }
);

export default _axios;
